/** ¿El dispositivo pide menos movimiento? Se consulta en cada animación (puede cambiar en vivo). */
export const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** La entrada del Inicio a velocidad 1 (card #585): Acople a 0,75×, o sea sus tiempos ÷ 0,75. */
export const ENTRANCE_MS = Math.round(520 / 0.75);
export const ENTRANCE_STEP_MS = Math.round(110 / 0.75);

/**
 * Entrada escalonada del Inicio de siempre (la que eligió Emmanuel el 21/10, card #585, maqueta
 * `docs/design/mejoras/demos/aviso-nave-en-viaje/entrada.html`, «La elegida»): el movimiento de
 * «Acople», con un cuarto de su rebote y llegando «desde más cerca» —cada sección aparece un poco más
 * grande (1,06), se apoya pasando apenas de largo (0,995) y se asienta—, con la luz de «Sin luz:
 * profundidad»: llega con una sombra profunda y algo apagada, y al apoyarse la sombra se achica. Sin
 * destellos ni anillo lima. Una sección tras otra, a 0,75× de Acople. El último cuadro no fija sombra
 * ni brillo: Web Animations completa con los de la tarjeta, así no salta al terminar. La línea de
 * arriba (`.h2-subhead-row`) no tiene borde: a ella no le toca la sombra.
 * Con movimiento reducido, un fundido de 200 ms, todas juntas.
 * Se resuelve cuando entró la última (o si se cortó): el aviso «Tu nave está en viaje» espera a eso.
 */
export function staggerIn(sections: readonly Element[]): Promise<void> {
  const reduced = prefersReducedMotion();
  const anims = sections.map((s, k) =>
    reduced
      ? s.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' })
      : s.animate(entranceFrames(s.classList.contains('h2-card')), {
          duration: ENTRANCE_MS,
          delay: k * ENTRANCE_STEP_MS,
          easing: 'ease-out',
          fill: 'backwards',
        }),
  );
  return Promise.all(anims.map((a) => a.finished)).then(
    () => undefined,
    () => undefined,
  );
}

/** Los cuadros de una sección: con sombra y brillo si es una tarjeta, sólo el movimiento si no. */
export function entranceFrames(card: boolean): Keyframe[] {
  const depth = (shadow: string, filter: string): Keyframe =>
    card ? { boxShadow: shadow, filter } : {};
  return [
    {
      opacity: 0,
      transform: 'scale(1.06)',
      ...depth('0 28px 44px -8px rgba(0, 0, 0, 0.75)', 'brightness(0.82)'),
    },
    {
      opacity: 1,
      transform: 'scale(0.995)',
      offset: 0.55,
      ...depth('0 3px 6px rgba(0, 0, 0, 0.55)', 'brightness(1.05)'),
    },
    {
      opacity: 1,
      transform: 'scale(1.0025)',
      offset: 0.8,
      ...depth('0 1px 2px rgba(0, 0, 0, 0.3)', 'none'),
    },
    { opacity: 1, transform: 'none' },
  ];
}
